import { render, staticRenderFns } from "./insights-page-header.vue?vue&type=template&id=4f644672&"
var script = {}
import style0 from "../../assets/styles/controls/_InsightsHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports